
import Aura from '@primeng/themes/aura';
import { definePreset } from '@primeng/themes';

const MyPreset = definePreset(Aura, {
    semantic: {
        primary: {
            50: 'var(--primary-light)',
            100: 'var(--primary-light)',
            200: 'var(--primary-light)',
            300: 'var(--primary-border)',
            400: 'var(--primary-border)',
            500: 'var(--primary)',
            600: 'var(--primary-hover)',
            700: 'var(--primary-dark)',
            800: 'var(--primary-dark)',
            900: 'var(--primary-dark-hover)',
            950: 'var(--primary-dark-hover)'
        }
    }
});


export const PrimeNGConfig = {
    theme: {
        preset: MyPreset,
        options: {
            ripple: true,
            darkModeSelector: '.dark',
            /* cssLayer: {
                name: 'primeng',
                order: 'tailwind-base, primeng, tailwind-utilities'
            } */
        }

    }
};
